import type { CSSProperties } from "react";
import { Text } from "../../typography";
import { classNames } from "../../utils/classNames";

export type LicensePlateProps = {
	plate: string;
	state: string;
	className?: string;
};

export const LicensePlate = ({ plate, state, className }: LicensePlateProps) => {
	return (
		<span
			className={classNames(
				"@container flex h-14 w-32 min-w-32 flex-col rounded-md border border-neutral-faded bg-white px-3 py-1 text-center",
				className,
			)}
		>
			<Text As="span" className="block truncate" size="xs" intent="muted" weight="bold">
				{state}
			</Text>
			<span className="my-auto block" style={{ "--plate-length": plate.length } as CSSProperties}>
				<Text
					As="span"
					className="block truncate text-[length:clamp(0.75rem,calc(85cqi/var(--plate-length)),1.125rem)]"
					weight="bold"
					intent="primary"
				>
					{plate}
				</Text>
			</span>
		</span>
	);
};
